const sentryDsn = process.env.SENTRY_DSN;
const sentryEnvironment = process.env.SENTRY_ENVIRONMENT;
const sentryRelease = process.env.SENTRY_RELEASE || null;

export { sentryDsn, sentryEnvironment, sentryRelease };
